import './polyfills';

import arTranslationMessages from '../../translations/compiled/ar.json';
import bgBGTranslationMessages from '../../translations/compiled/bg-BG.json';
import bnINTranslationMessages from '../../translations/compiled/bn-IN.json';
import csCZTranslationMessages from '../../translations/compiled/cs-CZ.json';
import deDETranslationMessages from '../../translations/compiled/de-DE.json';
import elGRTranslationMessages from '../../translations/compiled/el-GR.json';
import enTranslationMessages from '../../translations/compiled/en.json';
import enGBTranslationMessages from '../../translations/compiled/en-GB.json';
import esESTranslationMessages from '../../translations/compiled/es-ES.json';
import fiFITranslationMessages from '../../translations/compiled/fi-FI.json';
import frCATranslationMessages from '../../translations/compiled/fr-CA.json';
import frFRTranslationMessages from '../../translations/compiled/fr-FR.json';
import guINTranslationMessages from '../../translations/compiled/gu-IN.json';
import heILTranslationMessages from '../../translations/compiled/he-IL.json';
import hiINTranslationMessages from '../../translations/compiled/hi-IN.json';
import htHTTranslationMessages from '../../translations/compiled/ht-HT.json';
import idIDTranslationMessages from '../../translations/compiled/id-ID.json';
import itITTranslationMessages from '../../translations/compiled/it-IT.json';
import jaJPTranslationMessages from '../../translations/compiled/ja-JP.json';
import kaGETranslationMessages from '../../translations/compiled/ka-GE.json';
import knINTranslationMessages from '../../translations/compiled/kn-IN.json';
import koKRTranslationMessages from '../../translations/compiled/ko-KR.json';
import mlINTranslationMessages from '../../translations/compiled/ml-IN.json';
import mrINTranslationMessages from '../../translations/compiled/mr-IN.json';
import msMYTranslationMessages from '../../translations/compiled/ms-MY.json';
import nlNLTranslationMessages from '../../translations/compiled/nl-NL.json';
import noNOTranslationMessages from '../../translations/compiled/no-NO.json';
import orINTranslationMessages from '../../translations/compiled/or-IN.json';
import paINTranslationMessages from '../../translations/compiled/pa-IN.json';
import plPLTranslationMessages from '../../translations/compiled/pl-PL.json';
import ptBRTranslationMessages from '../../translations/compiled/pt-BR.json';
import roROTranslationMessages from '../../translations/compiled/ro-RO.json';
import ruRUTranslationMessages from '../../translations/compiled/ru-RU.json';
import svSETranslationMessages from '../../translations/compiled/sv-SE.json';
import taINTranslationMessages from '../../translations/compiled/ta-IN.json';
import teINTranslationMessages from '../../translations/compiled/te-IN.json';
import thTHTranslationMessages from '../../translations/compiled/th-TH.json';
import trTRTranslationMessages from '../../translations/compiled/tr-TR.json';
import ukUATranslationMessages from '../../translations/compiled/uk-UA.json';
import viVNTranslationMessages from '../../translations/compiled/vi-VN.json';
import zhCNTranslationMessages from '../../translations/compiled/zh-CN.json';
import zhTWTranslationMessages from '../../translations/compiled/zh-TW.json';

export const DEFAULT_LOCALE = 'en';

// prettier-ignore
export const appLocales = [
  'ar',
  'bg-BG',
  'bn-IN',
  'cs-CZ',
  'de-DE',
  'el-GR',
  'en',
  'es-ES',
  'fi-FI',
  'fr-FR',
  'fr-CA',
  'gu-IN',
  'he-IL',
  'hi-IN',
  'ht-HT',
  'id-ID',
  'it-IT',
  'ja-JP',
  'kn-IN',
  'ko-KR',
  'ml-IN',
  'mr-IN',
  'ms-MY',
  'nl-NL',
  'no-NO',
  'or-IN',
  'pa-IN',
  'pl-PL',
  'ro-RO',
  'ru-RU',
  'sv-SE',
  'ta-IN',
  'te-IN',
  'th-TH',
  'tr-TR',
  'vi-VN',
  'uk-UA',
  'zh-CN',
  'zh-TW',
  'ka-GE',
];

type Locale = string;
type Messages = Record<string, string>;
type MessagesByLocale = Record<Locale, Messages>;

export const translationMessages: MessagesByLocale = {
  ar: arTranslationMessages,
  'bg-BG': bgBGTranslationMessages,
  'bn-IN': bnINTranslationMessages,
  'cs-CZ': csCZTranslationMessages,
  'de-DE': deDETranslationMessages,
  'el-GR': elGRTranslationMessages,
  'en-US': enTranslationMessages,
  'en-GB': enGBTranslationMessages,
  'es-ES': esESTranslationMessages,
  'fi-FI': fiFITranslationMessages,
  'fr-FR': frFRTranslationMessages,
  'fr-CA': frCATranslationMessages,
  'gu-IN': guINTranslationMessages,
  'he-IL': heILTranslationMessages,
  'hi-IN': hiINTranslationMessages,
  'ht-HT': htHTTranslationMessages,
  'id-ID': idIDTranslationMessages,
  'it-IT': itITTranslationMessages,
  'ja-JP': jaJPTranslationMessages,
  'kn-IN': knINTranslationMessages,
  'ko-KR': koKRTranslationMessages,
  'ml-IN': mlINTranslationMessages,
  'mr-IN': mrINTranslationMessages,
  'ms-MY': msMYTranslationMessages,
  'nl-NL': nlNLTranslationMessages,
  'no-NO': noNOTranslationMessages,
  'pa-IN': paINTranslationMessages,
  'pl-PL': plPLTranslationMessages,
  'pt-BR': ptBRTranslationMessages,
  'or-IN': orINTranslationMessages,
  'ro-RO': roROTranslationMessages,
  'ru-RU': ruRUTranslationMessages,
  'sv-SE': svSETranslationMessages,
  'ta-IN': taINTranslationMessages,
  'te-IN': teINTranslationMessages,
  'th-TH': thTHTranslationMessages,
  'tr-TR': trTRTranslationMessages,
  'uk-UA': ukUATranslationMessages,
  'vi-VN': viVNTranslationMessages,
  'zh-CN': zhCNTranslationMessages,
  'zh-TW': zhTWTranslationMessages,
  'ka-GE': kaGETranslationMessages,
};
